export const qboProvider = {
  id: 'QUICKBOOKS',
  name: 'QuickBooks',
  iconColor: '#2ca01c',
  localStoragePrefix: 'qbo',
} as const

export type QboProvider = typeof qboProvider